<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-row>
        <AttachEventsUi v-model="showAttachEventsUiDialog"></AttachEventsUi>

        <view-event v-model="showEventDialog"
                    :selectedEvent="selectedEvent">
        </view-event>

        <new-edit-event v-model="showNewEditEventDialog"
                        :selectedEvent="selectedEvent">
        </new-edit-event>

        <delete-event v-model="showDeleteEventDialog"
                        :selectedEvent="selectedEvent">
        </delete-event>

        <v-col class="pt-4" cols="12" >
            <list-events :companyBlocked="companyBlocked"
                         :exportingData="exportingData"
                         @createEvent="createEvent()"
                         @exportAttendees="exportAttendees()"
                         @showAttachEventsUi="showAttachEventsUi()"
                         @showNewEditEvent="showNewEditEvent($event)"
                         @showDeleteEvent="showDeleteEvent($event)"
                         @viewEvent="showEvent($event)"/>
        </v-col>
    </v-row>
</template>

<script>
import AttachEventsUi from '@/pages/App/Events/AttachEventsUi.vue'
import eventsService from '@/services/eventsService.js'
import ListEvents from '@/pages/App/Events/ListEvents.vue'
import NewEditEvent from '@/pages/App/Events/dialogs/NewEditEvent.vue'
import DeleteEvent from '@/pages/App/Events/dialogs/DeleteEvent'
import notifications from '@/libs/notifications.js'
import ViewEvent from '@/pages/App/Events/dialogs/ViewEvent.vue'
export default {
  components: { AttachEventsUi, ListEvents, NewEditEvent, ViewEvent, DeleteEvent },
  computed: {
    companyBlocked () {
      return this.$store.getters.companyPaymentState === 'block' && !this.$store.getters.companyIsMonthlyBilling
    }
  },
  data () {
    return {
      exportingData: false,
      selectedEvent: '',
      showAttachEventsUiDialog: false,
      showEventDialog: false,
      showNewEditEventDialog: false,
      showDeleteEventDialog: false
    }
  },
  methods: {
    createEvent () {
      this.selectedEvent = ''
      this.showNewEditEventDialog = true
    },
    exportAttendees () {
      this.exportingData = true
      eventsService.exportData(
        this.$store.getters.token,
        this.$store.getters.companyUuid,
        this.$store.getters.appUuid,
        null,
        this.$t('general.assistants')
      ).then(() => {
        this.exportingData = false
        notifications.success(this.$t('general.assistantsExportedSuccessfully'))
      }).catch(error => {
        this.exportingData = false
        notifications.error(error.message)
      })
    },
    showAttachEventsUi () {
      this.showAttachEventsUiDialog = true
    },
    showEvent (event) {
      this.selectedEvent = event._id
      this.showEventDialog = true
    },
    showNewEditEvent (event) {
      this.selectedEvent = event._id
      this.showNewEditEventDialog = true
    },
    showDeleteEvent (event) {
      this.selectedEvent = event._id
      this.showDeleteEventDialog = true
    }
  },
  watch: {
    showEventDialog (value) {
      if (!value) this.selectedEvent = ''
    },
    showNewEditEventDialog (value) {
      if (!value) this.selectedEvent = ''
    },
    showDeleteEventDialog (value) {
      if (!value) this.selectedEvent = ''
    }
  }
}
</script>
